import { Controller } from "@hotwired/stimulus"

// Image preview — shows a thumbnail for an image URL field.
// Clicking thumbnail opens full-size in a lightbox modal.
//
// Targets:
//   input       — the hidden input storing the image path
//   preview     — the <img> element for the thumbnail
//   placeholder — element shown when no image is selected
//   removeBtn   — the remove button
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "removeBtn"]

  connect() {
    this.refresh()
    this.inputTarget.addEventListener("change", () => this.refresh())
    this.#ensureLightbox()
  }

  disconnect() {
    // Cleanup lightbox on Turbo navigation
    const lb = document.getElementById("preview-lb")
    if (lb && !document.querySelector("[data-controller=\"preview-image\"]")) {
      lb.remove()
    }
  }

  refresh() {
    const val = this.inputTarget.value
    if (val) {
      const url = `/en/media/image?path=${encodeURIComponent(val)}`
      this.previewTarget.src = url
      this.previewTarget.style.display = "block"
      if (this.hasPlaceholderTarget) this.placeholderTarget.style.display = "none"
      if (this.hasRemoveBtnTarget) this.removeBtnTarget.style.display = "inline-flex"
    } else {
      this.previewTarget.style.display = "none"
      if (this.hasPlaceholderTarget) this.placeholderTarget.style.display = "flex"
      if (this.hasRemoveBtnTarget) this.removeBtnTarget.style.display = "none"
    }
  }

  remove() {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  showFull() {
    const val = this.inputTarget.value
    if (!val) return
    this.#ensureLightbox()
    document.getElementById("preview-lb-img").src = `/en/media/image?path=${encodeURIComponent(val)}`
    document.getElementById("preview-lb-caption").textContent = val
    document.getElementById("preview-lb").style.display = "flex"
    document.body.style.overflow = "hidden"
  }

  #ensureLightbox() {
    if (document.getElementById("preview-lb")) return
    const div = document.createElement("div")
    div.id = "preview-lb"
    div.style.display = "none"
    div.innerHTML = `
      <div id="preview-lb-backdrop" style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;background:rgba(0,0,0,0.92);align-items:center;justify-content:center;cursor:pointer;">
        <button id="preview-lb-close" style="position:absolute;top:20px;right:30px;background:none;border:none;color:#fff;font-size:2rem;cursor:pointer;line-height:1;z-index:2;">&times;</button>
        <img id="preview-lb-img" src="" alt="" style="max-width:90vw;max-height:90vh;object-fit:contain;border-radius:6px;box-shadow:0 0 40px rgba(0,0,0,0.6);">
        <div id="preview-lb-caption" style="position:absolute;bottom:30px;left:0;right:0;text-align:center;color:#aaa;font-size:0.85rem;"></div>
      </div>
    `
    document.body.appendChild(div)

    document.getElementById("preview-lb-close").addEventListener("click", (e) => {
      e.stopPropagation()
      this.#closeLightbox()
    })
    document.getElementById("preview-lb-backdrop").addEventListener("click", (e) => {
      if (e.target.id === "preview-lb-backdrop") this.#closeLightbox()
    })
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.#closeLightbox()
    })
  }

  #closeLightbox() {
    const lb = document.getElementById("preview-lb")
    if (lb) {
      lb.style.display = "none"
      document.body.style.overflow = ""
    }
  }
}
